import { IdType } from '../../../../hoc/individual/types';

const getIdTypeName = (name: IdType) => {
  let idTypeName;

  switch (name) {
    case IdType.AGREEMENT:
      idTypeName = 'Agreement';
      break;
    case IdType.BANK_CARD:
      idTypeName = 'Bank Card';
      break;
    case IdType.CONTRACT:
      idTypeName = 'Contract';
      break;
    case IdType.COVID_VACCINATION_FORM:
      idTypeName = 'Covid Vaccination Form';
      break;
    case IdType.DRIVERS:
      idTypeName = 'Drivers';
      break;
    case IdType.DRIVERS_TRANSLATION:
      idTypeName = 'Drivers Translation';
      break;
    case IdType.ID_CARD:
      idTypeName = 'ID Card';
      break;
    case IdType.ID_DOC_PHOTO:
      idTypeName = 'ID Doc Photo';
      break;
    case IdType.INCOME_SOURCE:
      idTypeName = 'Income Source';
      break;
    case IdType.INVESTOR_DOC:
      idTypeName = 'Investor Doc';
      break;
    case IdType.OTHER:
      idTypeName = 'Other';
      break;
    case IdType.PASSPORT:
      idTypeName = 'Passport';
      break;
    case IdType.PAYMENT_METHOD:
      idTypeName = 'Payment Method';
      break;
    case IdType.PROFILE_IMAGE:
      idTypeName = 'Profile Image';
      break;
    case IdType.RESIDENCE_PERMIT:
      idTypeName = 'Residence Permit';
      break;
    case IdType.SELFIE:
      idTypeName = 'Selfie';
      break;
    case IdType.UTILITY_BILL:
      idTypeName = 'Utility Bill';
      break;
    case IdType.VEHICLE_REGISTRATION_CERTIFICATE:
      idTypeName = 'Vehicle Registration Certificate';
      break;
    case IdType.VIDEO_SELFIE:
      idTypeName = 'Video Selfie';
      break;
    default:
      idTypeName = name;
      break;
  }

  return idTypeName;
};

export default getIdTypeName;
